import decode from 'jwt-decode';
import { roles } from 'src/libs';
import { uiCapabilities } from 'src/permissions/uiCapabilities';

export const checkAdminAuth = () => {
  const token = localStorage.getItem('mern_admin_dashboard');
  if (!token) return false;

  try {
    const { exp, role } = decode(token);
    console.log("Decoded token>>>", decode(token))

    if (exp < new Date().getTime() / 1000) {
      return false;
    }
    if (role !== 'admin') {
      return false;
    }
  } catch (e) {
    return false;
  }

  return true;
};

export const checkAuth = () => {
  const token = localStorage.getItem('mern_admin_dashboard');
  if (!token) return false;

  try {
    const { exp, role } = decode(token);
    console.log("Decoded token>>>", decode(token))

    if (exp < new Date().getTime() / 1000) {
      return false;
    }
    if (!roles.includes(role)) {
      return false;
    }
  } catch (e) {
    return false;
  }

  return true;
};

export const getUser = () => {
  const token = localStorage.getItem('mern_admin_dashboard');
  if (!token) return null;

  try {
    const { exp, role } = decode(token);
    console.log("Decoded token>>>", decode(token))

    if (exp < new Date().getTime() / 1000) {
      return false;
    }
    if (!roles.includes(role)) {
      return false;
    }
  } catch (e) {
    return false;
  }

  return true;
}

//check user capabilities

export function can(user,capability) {
  if(!user?.role) return false;
  return Boolean(uiCapabilities[user.role]?.[capability]);
}
